import { apiClient, type TruckClassEntity } from '@/libs/api'

export const fetchTruckClasses = async (
  tenantKey: string,
  signal?: AbortSignal
): Promise<TruckClassEntity[]> => {
  const { data } = await apiClient._tenant(tenantKey).truck_classes.$get({
    config: {
      signal
    }
  })
  return data
}
